export default __webpack_public_path__ + "static/media/logo02.3ac52000.webp";